export const ForgotPasswordForm = {
  Email: 'email',
  ResetPasswordBtn: 'reset-password-btn',
};
